import { execute } from '../src/partialUpdate';

export default (params) => {
  execute(params);
  window.edeeshopPopup.close();
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/executeAndClose.js